const companyData = {
  sectores: [
    {
      label: "Agricultura",
      description:
        "Somos una empresa dedicada a la producción, cultivo y distribución de productos agrícolas frescos y de alta calidad, comprometidos con prácticas sostenibles y la satisfacción de nuestros clientes.",
      icon: "🌾",
    },
    {
      label: "Arquitectura y Diseño de interiores",
      description:
        "Nos especializamos en la planificación y diseño de espacios interiores y exteriores, creando ambientes funcionales y estéticamente impactantes para nuestros clientes.",
      icon: "🏛️",
    },
    {
      label: "Alimentos y Bebidas",
      description:
        "Elaboramos y comercializamos alimentos y bebidas de alta calidad, enfocándonos en satisfacer las necesidades de nuestros consumidores con productos innovadores y saludables.",
      icon: "🍴",
    },
    {
      label: "Banca",
      description:
        "Brindamos servicios financieros confiables, incluyendo préstamos, ahorros e inversiones, diseñados para apoyar a individuos y empresas en el manejo de sus recursos.",
      icon: "🏦",
    },
    {
      label: "Bienes Raíces",
      description:
        "Nos dedicamos a la compra, venta y alquiler de propiedades residenciales y comerciales, ayudando a nuestros clientes a encontrar la propiedad perfecta.",
      icon: "🏠",
    },
    {
      label: "Comercio y E-commerce",
      description:
        "Somos expertos en la venta de productos y servicios tanto en tiendas físicas como en plataformas en línea, ofreciendo una experiencia de compra única y conveniente.",
      icon: "🛒",
    },
    {
      label: "Consultoría Empresarial",
      description:
        "Proveemos asesoramiento estratégico para ayudar a empresas de todos los tamaños a optimizar sus operaciones y alcanzar sus objetivos de negocio.",
      icon: "💼",
    },
    {
      label: "Construcción",
      description:
        "Nos especializamos en la construcción de infraestructuras residenciales y comerciales, utilizando materiales de calidad y cumpliendo con los más altos estándares de seguridad.",
      icon: "🚧",
    },
    {
      label: "Contabilidad y Auditoría",
      description:
        "Ofrecemos servicios de gestión financiera y auditoría para garantizar la transparencia y el cumplimiento normativo de las empresas.",
      icon: "📊",
    },
    {
      label: "Diseño Gráfico y Multimedia",
      description:
        "Creamos contenido visual innovador para campañas publicitarias y proyectos digitales, ayudando a las marcas a destacarse en el mercado.",
      icon: "🎨",
    },
    {
      label: "Desarrollo de Software",
      description:
        "Desarrollamos aplicaciones digitales personalizadas y soluciones tecnológicas innovadoras para mejorar la productividad de nuestros clientes.",
      icon: "💻",
    },
    {
      label: "Educación Inicial, Primaria y Secundaria",
      description:
        "Proveemos servicios educativos de alta calidad para niños y adolescentes, fomentando el aprendizaje integral y el desarrollo personal.",
      icon: "📚",
    },
    {
      label: "Educación Superior",
      description:
        "Nos enfocamos en ofrecer formación avanzada y especializada a través de universidades, institutos y centros de educación superior.",
      icon: "🎓",
    },
    {
      label: "Energía",
      description:
        "Somos líderes en la producción y distribución de energía, incluyendo soluciones renovables y tradicionales, para impulsar el desarrollo sostenible.",
      icon: "⚡",
    },
    {
      label: "Hotelería",
      description:
        "Ofrecemos servicios de alojamiento de primera clase, proporcionando experiencias únicas para turistas y viajeros de negocios.",
      icon: "🏨",
    },
    {
      label: "Industria Textil",
      description:
        "Nos dedicamos a la fabricación y distribución de ropa y textiles, combinando calidad, estilo e innovación en cada pieza.",
      icon: "👗",
    },
    {
      label: "Logística y Distribución",
      description:
        "Gestionamos el transporte y la entrega de mercancías de manera eficiente, asegurando la puntualidad y la seguridad en cada envío.",
      icon: "🚚",
    },

    {
      label: "Materiales para Construcción",
      description:
        "Proveemos insumos de alta calidad para proyectos de construcción, desde materiales básicos hasta soluciones avanzadas.",
      icon: "🧱",
    },
    {
      label: "Medio Ambiente y Sostenibilidad",
      description:
        "Ofrecemos productos y servicios enfocados en la conservación del medio ambiente, promoviendo prácticas sostenibles en todos los sectores.",
      icon: "🌱",
    },
    {
      label: "Medios de Comunicación y Periodismo",
      description:
        "Producimos contenido informativo y de entretenimiento, manteniendo a las audiencias conectadas y bien informadas.",
      icon: "📰",
    },
    {
      label: "Minería y Extracción",
      description:
        "Nos especializamos en la extracción de minerales y recursos naturales, utilizando tecnologías avanzadas para minimizar el impacto ambiental.",
      icon: "⛏️",
    },
    {
      label: "Pesca y Acuicultura",
      description:
        "Producimos y comercializamos productos pesqueros de alta calidad, contribuyendo a la economía local y global.",
      icon: "🐟",
    },
    {
      label: "Recursos Humanos y Capacitación",
      description:
        "Ofrecemos servicios de gestión de talento y capacitación laboral, ayudando a las empresas a fortalecer sus equipos de trabajo.",
      icon: "👔",
    },
    {
      label: "Restaurantes y Servicios de Alimentos y Bebidas",
      description:
        "Nos especializamos en ofrecer experiencias culinarias únicas, con platos elaborados con los ingredientes más frescos y de alta calidad.",
      icon: "🍽️",
    },
    {
      label: "Salud y Medicina",
      description:
        "Proveemos servicios médicos de excelencia, con un equipo de profesionales altamente capacitados y tecnología de punta.",
      icon: "🩺",
    },
    {
      label: "Servicios de Belleza y Estética",
      description:
        "Ofrecemos tratamientos estéticos avanzados y servicios de belleza, ayudando a nuestros clientes a realzar su confianza y bienestar.",
      icon: "💅",
    },
    {
      label: "Servicios de Limpieza",
      description:
        "Brindamos soluciones de limpieza profesional para hogares y empresas, garantizando espacios impecables y saludables.",
      icon: "🧹",
    },
    {
      label: "Servicios de Seguridad",
      description:
        "Proveemos servicios y equipos de seguridad confiables, adaptados a las necesidades específicas de cada cliente.",
      icon: "🔒",
    },
    {
      label: "Servicios Legales",
      description:
        "Ofrecemos asesoramiento jurídico especializado, ayudando a individuos y empresas a resolver sus asuntos legales con eficiencia.",
      icon: "⚖️",
    },
    {
      label: "Tecnología",
      description:
        "Desarrollamos soluciones innovadoras en tecnologías de la información, impulsando la transformación digital de nuestros clientes.",
      icon: "🖥️",
    },
    {
      label: "Tecnología Financiera (Fintech)",
      description:
        "Proveemos soluciones tecnológicas que transforman y optimizan los servicios financieros para empresas e individuos.",
      icon: "💳",
    },
    {
      label: "Telecomunicaciones",
      description:
        "Ofrecemos servicios de conectividad avanzados, manteniendo a personas y empresas comunicadas en todo momento.",
      icon: "📡",
    },
    {
      label: "Turismo y Agencias de Viaje",
      description:
        "Organizamos experiencias de viaje inolvidables, diseñadas a medida para cada cliente, asegurando calidad y satisfacción.",
      icon: "✈️",
    },
  ],
};

export default companyData;
